module.exports = __webpack_public_path__ + "static/media/iconPlaceholder.1954d663.svg";